module.exports = __webpack_public_path__ + "static/Mrs Olasumbo Yates-137c432ac25d82c5b468487d8fbb2567.png";